module.exports = __webpack_public_path__ + "images/emoji/smoking.66dd54ea4661bb5eb6a1.png";